import { loadMoreBlueprint } from "@made-people/blueprint-load-more/blueprint";

loadMoreBlueprint.override({
  slots: {
    base: "flex flex-col items-center justify-center gap-4 py-12 max-w-[280px] col-span-12 place-self-center",
    seenProducts: "text-body-md",
    buttonWrapper: "w-full",
    progressbar: "w-full bg-surface-1 rounded-full overflow-hidden",
    progressbarFill: "h-2 bg-primary rounded-full",
  },
});
